export default {
  common: {
    add: '新增',
    edit: '编辑',
    detail: '详情',
    delete: '删除',
    batchDelete: '批量删除',
    submit: '提交',
    reset: '重置',
    search: '查询',
    refresh: '刷新',
    print: '打印',
    columnSettings: '列设置',
    action: '操作',
    confirm: '确定',
    cancel: '取消',
    noData: '暂无数据',
    inputPlaceholder: '请输入',
    selectPlaceholder: '请选择',
    datePlaceholder: '请选择日期',
    timePlaceholder: '请选择时间',
    startTime: '开始时间',
    endTime: '结束时间',
    operationSucceeded: '操作成功',
    deleteSucceeded: '删除成功',
    deleteConfirmTitle: '删除确认',
    deleteConfirm: '删除“{content}”后，相关业务引用可能失效，且数据无法恢复。请确认已核对影响范围。',
    selectedItems: '已选择 {count} 项'
  },
  app: {
    title: 'Ask Spinner 管理后台',
    home: '首页',
    foundation: '基础框架',
    componentLibrary: '通用组件库',
    richTextEditor: '富文本编辑器',
    placeholderTitle: '管理后台已就绪',
    placeholderDescription: '业务页面暂未接入。当前版本已完成 Vue、Element Plus 与核心通用组件的升级底座。'
  }
}
